import '../styles/application_mob.css'
